import { createSelector } from 'reselect'
import { Map } from 'immutable'

export const selectSearchManager = state => state.get('searchmanager') || Map()

export const selectDuplicatingSearchId = createSelector(
  selectSearchManager,
  query => query.get('duplicatingSearchId')
)
